import React from 'react';

const MDRHero = () => {
  return (
    <section className="relative  flex items-center justify-center overflow-hidden pt-10 lg:pt-0">
      
      {/* 1. DATA GRID BACKGROUND */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" />

      <div className="max-w-8xl mx-auto px-6 md:px-16 grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-12 lg:gap-[150px] items-center relative z-25">
        
        {/* LEFT CONTENT */}
        <div className="space-y-8 lg:space-y-12 w-full text-center lg:text-left"> 
          <div className="space-y-4 lg:space-y-6">
            <h1 className="text-5xl sm:text-6xl md:text-[65px] font-black text-white leading-[0.95] lg:leading-[0.9] tracking-tight">
              MANAGED <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-green to-emerald-600 italic">
                CYBER
              </span> <br className="hidden lg:block" />
              {' '}DEFENCE
            </h1>
          </div>

          <div className="relative inline-block lg:block">
            <p className="max-w-2xl text-gray-400 text-base sm:text-lg md:text-xl leading-relaxed font-medium mx-auto lg:mx-0">
              SecuWall’s Managed Cyber Defence combines elite human experts with advanced AI to actively     
              <span className="text-white"> monitor, detect, and stop threats 24/7</span>
              —before they turn into costly breaches.
            </p>
            {/* Gradient Line - Hidden on mobile to save horizontal space */}
            <div className="hidden lg:block absolute -left-6 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-emerald-500 to-transparent opacity-50" />
          </div>
        </div>

        {/* RIGHT SIDE: THE "CORE" ENGINE */}
        {/* Added scale-[0.6] sm:scale-[0.8] to make the rings fit mobile screens */}
        <div className="relative flex justify-center items-center h-[450px] sm:h-[600px] scale-[0.65] sm:scale-[0.85] lg:scale-100 transition-transform duration-500">
          
          {/* Main Rotating Ring */}
          {/* INNER RING (Rotating Clockwise) */}
          <div className="absolute w-[500px] h-[500px] animate-[spin_120s_linear_infinite]">
            {[...Array(60)].map((_, i) => ( // Reduced count for better performance on mobile
              <div
                key={`inner-${i}`}
                className="absolute top-0 left-1/2 -translate-x-1/2 h-full text-emerald-500/30 font-mono text-sm"
                style={{ transform: `rotate(${i * (360 / 60)}deg)` }}
              >
                <span className="block" style={{ transform: `rotate(-${i * (360 / 60)}deg)` }}>
                  {i % 2 === 0 ? "1" : "0"}
                </span>
              </div>
            ))}
          </div>

          {/* OUTER RING (Rotating Counter-Clockwise) */}
          <div className="absolute w-[550px] h-[550px] animate-[spin_60s_linear_infinite_reverse]">
            {[...Array(60)].map((_, i) => (
              <div
                key={`outer-${i}`}
                className="absolute top-0 left-1/2 -translate-x-1/2 h-full text-white/40 font-mono text-xs"
                style={{ transform: `rotate(${i * (360 / 60)}deg)` }}
              >
                <span className="block" style={{ transform: `rotate(-${i * (360 / 60)}deg)` }}>
                  {i % 2 === 0 ? "0" : "1"}
                </span>
              </div>
            ))}
          </div>

          {/* THE CIRCULAR IMAGE CONTAINER */}
          <div className="relative z-30 group">
            <div className="w-72 h-72 md:w-[420px] md:h-[420px] rounded-full border-[2px] border-white/30 lg:border-white/50 p-4 lg:p-6 bg-white/[0.02] backdrop-blur-3xl shadow-[0_0_50px_rgba(0,0,0,0.5)]">
              <div className="w-full h-full rounded-full overflow-hidden relative grayscale-[0.8] group-hover:grayscale-0 transition-all duration-1000">
                <img 
                  src="/mdr.png" 
                  alt="MDR Operations" 
                  className="w-full h-full object-cover scale-110 group-hover:scale-100 transition-transform duration-1000"
                />
                <div className="absolute inset-0 bg-emerald-900/20 group-hover:bg-transparent transition-colors duration-1000" />
              </div>
            </div>
          </div>

          {/* Decorative Geometric Accents - Adjusted visibility for mobile */}
          <div className="absolute -top-10 -right-10 lg:top-0 lg:right-0 w-24 h-24 lg:w-32 lg:h-32 border-[15px] lg:border-[20px] border-white/20 rounded-full" />
          <div className="absolute bottom-10 -left-10 lg:left-0 w-16 h-16 lg:w-20 lg:h-20 border-[8px] lg:border-[10px] border-emerald-500/20 rounded-full" />
        </div>

      </div>
    </section>
  );
};

export default MDRHero;